import { updateLinksAttributes } from '../utils/handleAttributes';
import { missingWidget } from '../utils/helpers';
import MicroModal from 'micromodal';

// -----------------------
// pop up settings
// behavior
const popUpSettings = {
  homepageOnly: true,
  cookiesEnabled: {
    enabled: true,
    expiration: 15,
  },
};

// button labels
const buttonsLabels = {
  learnMore: 'Learn More',
  purchaseLabel: 'Explore More',
};

export default function customPopUp(triggerClass) {
  const widgetName = 'customPopUp';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof customPopUpOpts === 'undefined' ? null : customPopUpOpts;

  if (!widgetOpts) {
    $widget.remove();
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomPopUp(data.items[0], triggerClass);
      }

      $widget.remove();
    },
  });
}

// -----------------------
// buttons
const appendButtons = function (btn1, btn2) {
  if (!btn1 && !btn2) {
    return '';
  }

  const $btnContainer = $('<div class="modal__buttons-container"></div>');

  if (btn1) {
    $btnContainer.append(
      `<a href="${btn1}" class="button" ${updateLinksAttributes(btn1, buttonsLabels.learnMore)}>${buttonsLabels.learnMore}</a>`,
    );
  }

  if (btn2) {
    $btnContainer.append(
      `<a href="${btn2}" class="button" ${updateLinksAttributes(btn2, buttonsLabels.purchaseLabel)}>${buttonsLabels.purchaseLabel}</a>`,
    );
  }

  return $btnContainer.prop('outerHTML');
};

function appendPopUpImage(ImageWithPath, ImageAlternateText) {
  if (!ImageWithPath && !ImageAlternateText) {
    return '';
  }

  return `
  <div class="modal__image-container">
  <img src="${ImageWithPath}" alt="${ImageAlternateText}">
  </div>
  `;
}

// pop up template
const popupTemplate = function (title, description, buttons, ImageWithPath, ImageAlternateText) {
  return `
    <div class="modalPopUp micromodal-slide" id="signup-modal" aria-hidden="true">
      <div class="modal__overlay" tabindex="-1">
        <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="signup-modal-title">

          <header class="modal__header">
            <h2 class="modal__title" id="signup-modal-title">${title}</h2>
            <button class="button modal__close" aria-label="Close modal" data-micromodal-close></button>
          </header>

          <main class="modal__content" id="signup-modal-content">
            ${appendPopUpImage(ImageWithPath, ImageAlternateText)}
            <div class="modal__description" id="signup-modal-description">
              ${description}
            </div>
          </main>
            ${buttons}

        </div>
      </div>
    </div>
  `;
};

function createCustomPopUp(widgetData, triggerClass) {
  const { Title, Description, URL, PurchaseURL, ImageWithPath, ImageAlternateText } = widgetData;
  const isHomepage = $('body').hasClass(triggerClass);
  const { homepageOnly, cookiesEnabled } = popUpSettings;

  if (homepageOnly && !isHomepage) {
    return;
  }

  if (cookiesEnabled.enabled && !navigator.cookieEnabled) {
    return;
  }

  if (cookiesEnabled.enabled && Cookies.get('modalCookie') !== undefined) {
    return;
  }

  initializePopupModal(Title, Description, URL, PurchaseURL, ImageWithPath, ImageAlternateText);
}

function initializePopupModal(
  title,
  description,
  url,
  purchaseUrl,
  ImageWithPath,
  ImageAlternateText,
) {
  $('body').append(
    popupTemplate(
      title,
      description,
      appendButtons(url, purchaseUrl),
      ImageWithPath,
      ImageAlternateText,
    ),
  );

  MicroModal.init({
    onClose: () => {
      document.activeElement?.blur();

      setTimeout(() => {
        $('#signup-modal').remove();
      }, 100);
    },
    openClass: 'is-open',
    disableScroll: true,
    disableFocus: false,
    awaitOpenAnimation: true,
    awaitCloseAnimation: true,
    debugMode: false,
  });

  setTimeout(() => {
    MicroModal.show('signup-modal');

    if (popUpSettings.cookiesEnabled.enabled) {
      Cookies.set('modalCookie', 'modalCookie', {
        expires: popUpSettings.cookiesEnabled.expiration,
      });
    }
  }, 300);
}
